import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5.124 12.1136L5.12669 12.1264C5.50897 13.9413 6.73214 15.4995 8.46323 16.2864L12 17.894V16H14C16.7614 16 19 13.7614 19 11V10C19 7.23858 16.7614 5 14 5H10C7.23858 5 5 7.23858 5 10V11C5 11.3804 5.04211 11.7485 5.12115 12.1009L5.124 12.1136ZM14 21L7.63562 18.1071C5.31787 17.0536 3.68127 14.9677 3.16963 12.5386C3.05859 12.0435 3 11.5286 3 11V10C3 6.13401 6.13401 3 10 3H14C17.866 3 21 6.13401 21 10V11C21 14.866 17.866 18 14 18V21Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MessageRound"
);
